import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { message } from 'antd';
import { t } from 'i18next';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = (_api: MiddlewareAPI) => (next) => (action: any) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    // if (action?.payload?.data?.status === 404) {
    // } else {
    message.error(action?.payload?.data?.message ?? action?.payload?.error ?? t('errors.defaultErrorText'));
    // }
  }

  return next(action);
};
